function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Represents a location in the component
 * @constructor
 * @memberOf module:wdh-locations-spot
 */
var Location = /*#__PURE__*/function () {
  function Location() {
    _classCallCheck(this, Location);

    /**
     * @type {string}
     */
    this.UniqueId = '';
    /**
     * @type {string}
     */

    this.Name = '';
    /**
     * @type {number}
     */

    this.Latitude = 0;
    /**
     * @type {number}
     */

    this.Longitude = 0;
    /**
     * @type {string}
     */

    this.Address = '';
    /**
     * @type {string}
     */

    this.City = '';
    /**
     * @type {string}
     */

    this.Country = '';
    /**
     * @type {string}
     */

    this.Description = '';
    /**
     * @type {string}
     */

    this.Email = '';
    /**
     * @type {string}
     */

    this.FormattedAddress = '';
    /**
     * @type {string}
     */

    this.Homepage = '';
    /**
     * @type {number}
     */

    this.LocationType = -1;
    /**
     * @type {string}
     */

    this.OpeningHours = '';
    /**
     * @type {string}
     */

    this.Phone = '';
    /**
     * @type {string}
     */

    this.PostalCode = '';
    /**
     * @type {string}
     */

    this.Region = '';
    /**
     * @type {number}
     */

    this.Distance = 0;
    /**
     * US Oticon.com
     * @type {boolean}
     */

    this.RiskFreeTrial = false;
    /**
     * US Oticon.com
     * @type {boolean}
     */

    this.SoldQty = false;
    /**
     * @type {string}
     */

    this.CustomerNumber = '';
  }

  _createClass(Location, [{
    key: "lat",
    get: function get() {
      return this.Latitude;
    }
  }, {
    key: "lng",
    get: function get() {
      return this.Longitude;
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      return this.lat === 0 && this.lng === 0;
    }
  }, {
    key: "equals",
    value: function equals(location) {
      return location.UniqueId === this.UniqueId;
    }
  }, {
    key: "contactDetailsToString",
    value: function contactDetailsToString(fields) {
      var _this = this;

      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ';';
      var details = '';
      fields.forEach(function (field) {
        details += "".concat(_this[field]).concat(delimiter);
      });
      return details;
    }
  }], [{
    key: "fromWebserviceData",
    value: function fromWebserviceData(data) {
      var loc = new Location();
      loc.Name = data.Name;
      loc.UniqueId = data.UniqueId;
      loc.Latitude = data.Latitude;
      loc.Longitude = data.Longitude;
      loc.Address = data.Address;
      loc.City = data.City;
      loc.Country = data.Country;
      loc.Description = data.Description;
      loc.Email = data.Email;
      loc.FormattedAddress = data.FormattedAddress;
      loc.Homepage = data.Homepage;
      loc.LocationType = data.LocationType;
      loc.OpeningHours = data.OpeningHours;
      loc.Phone = data.Phone;
      loc.PostalCode = data.PostalCode;
      loc.Region = data.Region;
      loc.RiskFreeTrial = data.RiskFreeTrial.toString();
      loc.SoldQty = data.SoldQty.toString();
      loc.CustomerNumber = data.CustomerNumber;
      return loc;
    }
  }, {
    key: "fromGooglePlace",
    value: function fromGooglePlace(place) {
      var loc = new Location();
      loc.Latitude = place.geometry.location.lat();
      loc.Longitude = place.geometry.location.lng();
      loc.Name = place.name;
      return loc;
    }
  }, {
    key: "fromSettings",
    value: function fromSettings(data) {
      var loc = new Location();
      loc.Latitude = data.Latitude;
      loc.Longitude = data.Longitude;
      return loc;
    }
  }, {
    key: "fromGeolocation",
    value: function fromGeolocation(data) {
      var loc = new Location();
      loc.Latitude = data.latitude;
      loc.Longitude = data.longitude;
      return loc;
    }
  }, {
    key: "fromObject",
    value: function fromObject(object) {
      var loc = new Location();
      Object.assign(loc, object);
      return loc;
    }
  }, {
    key: "fromCoordinateArray",
    value: function fromCoordinateArray(coord) {
      var loc = new Location();

      var _coord = _slicedToArray(coord, 2);

      loc.Latitude = _coord[0];
      loc.Longitude = _coord[1];
      return loc;
    }
  }]);

  return Location;
}();

export default Location;